<template>
   <div class="NkUpsLine">
       <div class="box">
			<div :id="lineId" class="line"></div>
		</div>
   </div>
</template>
<script>
  import uuidv1 from "uuid/v1";
  export default {
    name: 'NkUpsLine',
    props: { 
        lineData: {  
            type: Object,
            default: ()=>({
            })
        }
  },
    data() {
        return {
            time: "111",
            collapse: false,
            id:1111111,
            lineData1:{
                x:["12-13 1997","07-09 1998","03-14 1999","12-13 1997","11-17 1999","07-22 2000"],
                name:"张三",
                data:[2,4,6,8,10,12]
            },
            lineId:uuidv1(),
            myChart:null,
            echatData:{}
        };
    },
    created() {
        console.log(this.time)
        console.log(this.id)
    },
    watch: {
    },
    mounted(){
        this.echatData=this.lineData
        let initData=this.initData(this.echatData)
        console.log(initData)
        console.log(this.lineId)
        this.filldanline(initData)
    },
    methods: {
        //格式化需要传入的值
        initData(obj){  
            let dyd=obj
            let newObj={
                x:obj.x,
                series:[
                    {
                        name:dyd.name,
                        type:"line",
                        data:dyd.data
                    }
                ]
                    
            }
            return newObj
        },
        //柱状图
        filldanline(obj){  
            let this_ = this;
            if (this_.myChart != null && this_.myChart != "" && this_.myChart != undefined) {
                this_.myChart.dispose();
            }
            this_.myChart = this_.$echarts.init(document.getElementById(this.lineId));
            var option = {
                tooltip: {
                    trigger: 'axis',
                },
                color:["#DC6B66","#2fc25b","#DC143C"],
                grid: {
                    containLabel: true,
                    left: '1px',
                    right: '1px',
                    bottom: '10px',
                    top:'7px',
                },
                xAxis: [{
                    type: 'category',
                    data: obj.x,
                    boundaryGap:false,
                    axisTick:{
                        show:true
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff',
                            fontSize:10,
                        },
                        // interval:0,//全部显示
                        formatter: function(params) {
                            var newParamsName = ""; // 最终拼接成的字符串
                            var paramsNameNumber = params.length; // 实际标签的个数
                            var provideNumber = 5; // 每行能显示的字的个数
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                            /**
                             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                             */
                            // 条件等同于rowNumber>1
                            if (paramsNameNumber > provideNumber) {
                                /** 循环每一行,p表示行 */
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = ""; // 表示每一次截取的字符串
                                    var start = p * provideNumber; // 开始截取的位置
                                    var end = start + provideNumber; // 结束截取的位置
                                    // 此处特殊处理最后一行的索引值
                                    if (p == rowNumber - 1) {
                                        // 最后一次不换行
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        // 每一次拼接字符串并换行
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr; // 最终拼成的字符串
                                }
            
                            } else {
                                // 将旧标签的值赋给新标签
                                newParamsName = params;
                            }
                            //将最终的字符串返回
                            return newParamsName
                        }
                    },
                }],
                yAxis: {
                    type: "value",
                     axisLabel : {
                        // formatter: '{value}',
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series:obj.series
            };
            this_.myChart.setOption(option,true);
            if(this_.myChart){
                window.addEventListener("resize",function(){
                    this_.myChart.resize();
                });
            }
        }
    }
  };
</script>
<style lang="scss" scoped>
  .NkUpsLine {
      height: 100%;
      width:100%;
      .box{
        width:100%;height:100%;background: rgba(51, 51, 51);;
        // width:100%;height:100%;background: #FFF;;
        .line{
            width:100%;height:100%; 
        } 
      }
  };
  </style>
  